// Billing bridge — invokes the existing Supabase Edge Functions
// `billing-checkout` and `billing-portal` directly from the browser.
// On Electron the response URL is opened via shell.openExternal; on
// web we just navigate the current tab (or open a new tab) to the
// returned Stripe URL.

async function callEdge({ supabase, env, path, body }) {
  if (!supabase) return { ok: false, error: 'Supabase not configured' };
  const { data: sess } = await supabase.auth.getSession();
  const jwt = sess?.session?.access_token;
  if (!jwt) return { ok: false, error: 'Sign in to manage billing.', code: 'auth-missing' };
  if (!env.SUPABASE_URL) return { ok: false, error: 'Supabase URL not configured' };

  const url = `${env.SUPABASE_URL.replace(/\/$/, '')}/functions/v1/${path}`;
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json', authorization: `Bearer ${jwt}` },
    body: JSON.stringify(body || {}),
  });
  let parsed = null;
  try {
    parsed = await res.json();
  } catch {
    /* empty */
  }
  if (!res.ok || !parsed || parsed.ok === false || !parsed.url) {
    return {
      ok: false,
      error: (parsed && (parsed.error || parsed.code)) || `HTTP ${res.status}`,
    };
  }
  return { ok: true, url: parsed.url };
}

export function buildBillingHandlers({ supabase, env }) {
  return {
    async billingCheckout(tier, cadence) {
      // Renderer calls with positional args (Electron preload sends
      // them as `{ tier, cadence }` to the IPC channel; the web
      // bridge IS the renderer-facing surface, so accept positional
      // and re-wrap for the Edge Function body.
      const r = await callEdge({
        supabase,
        env,
        path: 'billing-checkout',
        body: { tier, cadence, client_type: 'web' },
      });
      if (r.ok) {
        // Same-tab navigation matches Stripe's recommended flow and
        // avoids popup-blocker friction. Plan-page is briefly empty
        // while Stripe loads.
        window.location.assign(r.url);
      }
      return r;
    },

    async billingPortal() {
      const r = await callEdge({
        supabase,
        env,
        path: 'billing-portal',
        body: { client_type: 'web' },
      });
      if (r.ok) {
        window.location.assign(r.url);
      }
      return r;
    },
  };
}
